export default "__VITE_PUBLIC_ASSET__8d036b0c__"